
import 'es5-shim';
import 'es6-shim';
import 'es6-promise';
import 'core-js/shim'; //IE11 support
//import('./plugins/d3.js'); // TODO !!! Provjerit radi li
import * as Sentry from '@sentry/browser';
Sentry.init({
  dsn: 'https://5e7437a7399c48c78b50d06b937deeb8@sentry.io/267686',
  beforeSend: (event, hint) => {
    const capturedObj = hint.originalException;

    // handle CustomEvents which have real Errors buried inside them
    if (
      capturedObj instanceof CustomEvent &&
      capturedObj.detail &&
      capturedObj.detail.reason &&
      capturedObj.detail.reason instanceof Error
    ) {
      Sentry.withScope(scope => {
        // pull out the embedded Error object
        const buriedError = capturedObj.detail.reason;
        capturedObj.detail.reason = "<error object captured above>";

        // capture the rest of the CustomEvent's data as extra
        Sentry.setExtras({
          originalThrownObject: capturedObj
        });

        // create a new event out of the real Error, annotated with the other data
        Sentry.captureException(buriedError);
      });

      // don't send the original, badly-structured event
      return null;
    }

    return event;
  }
});

import { detectedApp, getParameterByName, RLLoadingFunction  } from './api/common';

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import classNames from 'classnames';

import * as jQuery from 'jquery';
import configureStore from './redux/store/configure-store';

// import LiveVideoHomepage from './containers/liveVideoHomepage';
// import CourseHomePage from './containers/courseHomePage';
// import ModuleView from './containers/moduleView';
// import AdminTools from './containers/adminTools';
// import Discussions from './containers/discussions';
// import ManageCourses from './containers/manageCourses';
// import GroupsManager from './containers/groupsManager';
// import GroupsRegister from './containers/groupsRegister';
// import FAQ from './containers/FAQ';
// import NotFound from './containers/notFound';
// import EditCourse from './components/editCourse/editCourse';
// import AboutLiveProject from './components/aboutLiveProject/aboutLiveProject';
// import ProjectHomepage from './components/projectHomepage/projectHomepage';
// import ShadowControl from './components/shadowControl/shadowControl';
// import HeaderModule from './components/headerModule/headerModule';
// import TocMenu from './components/tocMenu/tocMenu';
// import FooterModule from './components/footerModule/footerModule';
// import FooterEditModule from './components/footerEditModule/footerEditModule';

// /** Loadable components */
import Loadable from 'react-loadable';
const ShadowControl = Loadable({
  loader: () => import('./components/shadowControl/shadowControl'),
  loading: RLLoadingFunction,
})
const CourseHomePage = Loadable({
  loader: () => import('./containers/courseHomePage'),
  loading: RLLoadingFunction,
})
const LiveVideoHomepage = Loadable({
  loader: () => import('./containers/liveVideoHomepage'),
  loading: RLLoadingFunction,
})
const ModuleView = Loadable({
  loader: () => import('./containers/moduleView'),
  loading: RLLoadingFunction,
})
const AdminTools = Loadable({
  loader: () => import('./containers/adminTools'),
  loading: RLLoadingFunction,
})
const Discussions = Loadable({
  loader: () => import('./containers/discussions'),
  loading: RLLoadingFunction,
})
const ManageCourses = Loadable({
  loader: () => import('./containers/manageCourses'),
  loading: RLLoadingFunction,
})
const GroupsManager = Loadable({
  loader: () => import('./containers/groupsManager'),
  loading: RLLoadingFunction,
})
// const GroupsRegister = Loadable({
//   loader: () => import('./containers/groupsRegister'),
//   loading: RLLoadingFunction,
// })
const FAQ = Loadable({
  loader: () => import('./containers/FAQ'),
  loading: RLLoadingFunction,
})
const NotFound = Loadable({
  loader: () => import('./containers/notFound'),
  loading: RLLoadingFunction,
})
const EditCourse = Loadable({
  loader: () => import('./components/editCourse/editCourse'),
  loading: RLLoadingFunction,
})
const AboutLiveProject = Loadable({
  loader: () => import('./components/aboutLiveProject/aboutLiveProject'),
  loading: RLLoadingFunction,
})
const ProjectHomepage = Loadable({
  loader: () => import('./components/projectHomepage/projectHomepage'),
  loading: RLLoadingFunction,
})

const AggregatedFeedback = Loadable({
  loader: () => import('./containers/aggregatedFeedbackContainer'),
  loading: RLLoadingFunction,
})

const TocMenu = Loadable({
  loader: () => import('./components/tocMenu/tocMenu'),
  loading: RLLoadingFunction,
})

const FooterEditModule = Loadable({
  loader: () => import('./components/footerEditModule/footerEditModule'),
  loading: RLLoadingFunction,
})
const HeaderModule = Loadable({
  loader: () => import('./components/headerModule/headerModule'),
  loading: RLLoadingFunction,
})

const FooterModule = Loadable({
  loader: () => import('./components/footerModule/footerModule'),
  loading: RLLoadingFunction,
})

const Social = Loadable({
  loader: () => import('./components/social/social'),
  loading: RLLoadingFunction,
})

const MentorUI = Loadable({
  loader: () => import('./containers/mentorUI'),
  loading: RLLoadingFunction,
})

/** CSS */
// import './styles/bootstrap/dist/css/bootstrap.min.css';
import './styles/bootstrap_extracted.css'
import './styles/main.css';
import './styles/newMobile.css';
import './styles/main.scss';
import './styles/themes/headers.scss';
import './styles/themes/various.scss';

//Microtransactions are disabled
// import './styles/unscramble.css';

/** dynamically created css files to enable code splitting */

//import './styles/exercises.css'; //vbook-ui-components
//import './styles/react-tabs.css'; //vbook-ui-components
//import './styles/tryIts.css'; //vbook-ui-components
//import './styles/codemirror.css'; //vbook-ui-components
//import './styles/codeMirrorThemes/motheb-day.css'; //vbook-ui-components

import {
  LIVEVIDEO_DEFULT_THEME,
  CURRENT_APP_LIVEVIDEO,
  CURRENT_APP_LIVEPROJECT,
  LIVEPROJECT_DEFULT_THEME,
  LIVEPROJECT_PURPLE_THEME,
  LIVEPROJECT_BLUE_THEME
} from './constants';
import PlatformUtils from './adapters/PlatformUtils';


(window as any).jQuery = jQuery;

const store = configureStore({});
//const history = syncHistoryWithStore(browserHistory, store);

const editModeProps = {
  isEditMode: true,
}
const normalModeProps = {
  isEditMode: false,
}


const headerClasses = classNames({
  "header": true,
})
const footerClasses = classNames({
  "footer": true,
})

let app = detectedApp();

let theme = LIVEVIDEO_DEFULT_THEME;
switch (app) {
  case CURRENT_APP_LIVEVIDEO:
    theme = LIVEVIDEO_DEFULT_THEME;
    break;
  case CURRENT_APP_LIVEPROJECT:
    theme = LIVEPROJECT_DEFULT_THEME;
    break;
  default:
    theme = LIVEVIDEO_DEFULT_THEME;
    break;
}

if (getParameterByName("liveProjectPurple") === "true") {
  theme = LIVEPROJECT_PURPLE_THEME;
}
if (getParameterByName("liveProjectBlue") === "true") {
  theme = LIVEPROJECT_BLUE_THEME;
}

let mainClasses = classNames({
  "theme-liveVideoDefault": theme === LIVEVIDEO_DEFULT_THEME,
  //"theme-liveProjectPurple": theme === LIVEPROJECT_PURPLE_THEME,
  //"theme-liveProjectBlue": theme === LIVEPROJECT_BLUE_THEME,
  "theme-liveProjectDefault": theme === LIVEPROJECT_DEFULT_THEME,
})

jQuery("body").addClass(mainClasses)

ReactDOM.render(
  <div className={mainClasses}>
    <Provider store={store}>
      <Router>
        <Switch>
          {/* <Route exact path="/" component={LiveVideoHomepage} /> */}

          <Route exact path="/" render={(routeProps) => {
            return (
              <React.Fragment >
                {
                  PlatformUtils.isLiveProject() ?
                    <AboutLiveProject {...routeProps} />
                    :
                    <LiveVideoHomepage {...routeProps} />
                }
                <ShadowControl key="shadowControl" version={"root"} />
              </React.Fragment>
            )
          }} />


          <Route exact path="/course/:id" render={(routeProps) => {
            const toContinue = getParameterByName("continue") || false;
            const toDownload = getParameterByName("download") || false;
            const findPromo = getParameterByName("findPromo") || false;
            const commentIdForOpening = getParameterByName("comment");
            const commentSpam = getParameterByName("comment-spam");
            const commentEditSuggestion = getParameterByName("comment-edit-suggestion");
            const commentNotSpam = getParameterByName("comment-not-spam");
            const discussionsVisible = getParameterByName("discussions");
            if (!toContinue && !toDownload && !findPromo && !commentIdForOpening && !commentSpam && !commentEditSuggestion && !commentNotSpam && !discussionsVisible) {
              return (
                <React.Fragment >
                  <Redirect to={`/module/${routeProps?.match?.params?.id}_1_1`} />
                  <ShadowControl key="shadowControl" version={"coursePage"} />
                </React.Fragment>
              )
            } else {
              return (
                <React.Fragment >
                  <CourseHomePage {...routeProps} />
                  <ShadowControl key="shadowControl" version={"coursePage"} />
                </React.Fragment>
              )
            }
          }} />

          <Route exact path="/course/:id/:courseSlug" render={(routeProps) => {
            const toContinue = getParameterByName("continue") || false;
            const toDownload = getParameterByName("download") || false;
            const findPromo = getParameterByName("findPromo") || false;
            const commentIdForOpening = getParameterByName("comment");
            const commentSpam = getParameterByName("comment-spam");
            const commentEditSuggestion = getParameterByName("comment-edit-suggestion");
            const commentNotSpam = getParameterByName("comment-not-spam");
            const discussionsVisible = getParameterByName("discussions");
            if (!toContinue && !toDownload && !findPromo && !commentIdForOpening && !commentSpam && !commentEditSuggestion && !commentNotSpam && !discussionsVisible) {
              return (
                <React.Fragment >
                  <Redirect to={`/module/${routeProps?.match?.params?.id}_1_1`} />
                  <ShadowControl key="shadowControl" version={"coursePage"} />
                </React.Fragment>
              )
            } else {
              return (
                <React.Fragment >
                  <CourseHomePage {...routeProps} />
                  <ShadowControl key="shadowControl" version={"coursePage"} />
                </React.Fragment>
              )
            }
          }} />

          <Route exact path="/module/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={false} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={false} />
                  <div className="module-wrapper">
                    <ModuleView {...routeProps} {...normalModeProps} />
                    <Discussions
                      moduleIden={routeProps.match.params.id}
                      disableCloseInDiscussions={PlatformUtils.shouldDisableCloseInDiscussions()}
                      key={PlatformUtils.shouldReloadDiscussionsOnChange() ? routeProps.match.params.id : null}
                      shownIn={"moduleView"} />
                  </div>
                </div>
                <div className={footerClasses}>
                  <FooterModule screenWidth={window.innerWidth} />
                </div>
                <ShadowControl key="shadowControl" version={"moduleView"} moduleIden={routeProps.match.params.id} />
              </React.Fragment>
            )
          }} />
          <Route exact path="/module/:id/:courseSlug/:unitSlug/:moduleSlug" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={false} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={false} />
                  <div className="module-wrapper">
                    <ModuleView {...routeProps} {...normalModeProps} />
                    <Discussions
                      moduleIden={routeProps.match.params.id}
                      disableCloseInDiscussions={PlatformUtils.shouldDisableCloseInDiscussions()}
                      key={PlatformUtils.shouldReloadDiscussionsOnChange() ? routeProps.match.params.id : null}
                      shownIn={"moduleView"} />
                  </div>
                </div>
                <div className={footerClasses}>
                  <FooterModule screenWidth={window.innerWidth} />
                </div>
                <ShadowControl key="shadowControl" version={"moduleView"} moduleIden={routeProps.match.params.id} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/promo/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={false} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={false} />
                  <div className="module-wrapper">
                    <ModuleView {...routeProps} {...normalModeProps} />
                    <Discussions
                      moduleIden={routeProps.match.params.id}
                      disableCloseInDiscussions={PlatformUtils.shouldDisableCloseInDiscussions()}
                      key={PlatformUtils.shouldReloadDiscussionsOnChange() ? routeProps.match.params.id : null}
                      shownIn={"promoView"} />
                  </div>
                </div>
                <div className={footerClasses}>
                  <FooterModule screenWidth={window.innerWidth} />
                </div>
                <ShadowControl key="shadowControl" version={"moduleView"} moduleIden={routeProps.match.params.id} />
              </React.Fragment>
            )
          }} />
          <Route exact path="/promo/:id/:courseSlug/:unitSlug/:moduleSlug" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={false} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={false} />
                  <div className="module-wrapper">
                    <ModuleView {...routeProps} {...normalModeProps} />
                    <Discussions
                      moduleIden={routeProps.match.params.id}
                      disableCloseInDiscussions={PlatformUtils.shouldDisableCloseInDiscussions()}
                      key={PlatformUtils.shouldReloadDiscussionsOnChange() ? routeProps.match.params.id : null}
                      shownIn={"promoView"} />
                  </div>
                </div>
                <div className={footerClasses}>
                  <FooterModule screenWidth={window.innerWidth} />
                </div>
                <ShadowControl key="shadowControl" version={"moduleView"} moduleIden={routeProps.match.params.id} />
              </React.Fragment>
            )
          }} />


          <Route exact path="/search/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={false} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={false} />
                  <div className="module-wrapper">
                    <ModuleView {...routeProps} {...normalModeProps} />
                    <Discussions
                      moduleIden={routeProps.match.params.id}
                      disableCloseInDiscussions={PlatformUtils.shouldDisableCloseInDiscussions()}
                      key={PlatformUtils.shouldReloadDiscussionsOnChange() ? routeProps.match.params.id : null}
                      shownIn={"searchView"} />
                  </div>
                </div>
                <div className={footerClasses}>
                  <FooterModule screenWidth={window.innerWidth} />
                </div>
                <ShadowControl key="shadowControl" version={"moduleView"} moduleIden={routeProps.match.params.id} />
              </React.Fragment>
            )
          }} />
          <Route exact path="/search/:id/:courseSlug/:unitSlug/:moduleSlug" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={false} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={false} />
                  <div className="module-wrapper">
                    <ModuleView {...routeProps} {...normalModeProps} />
                    <Discussions
                      moduleIden={routeProps.match.params.id}
                      disableCloseInDiscussions={PlatformUtils.shouldDisableCloseInDiscussions()}
                      key={PlatformUtils.shouldReloadDiscussionsOnChange() ? routeProps.match.params.id : null}
                      shownIn={"searchView"} />
                  </div>
                </div>
                <div className={footerClasses}>
                  <FooterModule screenWidth={window.innerWidth} />
                </div>
                <ShadowControl key="shadowControl" version={"moduleView"} moduleIden={routeProps.match.params.id} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/editmodule/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={true} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={true} />
                  <ModuleView {...routeProps} {...editModeProps} />
                </div>
                <div className={footerClasses}>
                  <FooterEditModule moduleIden={routeProps.match.params.id} />
                </div>
                <ShadowControl key="shadowControl" version={"editModuleView"} />
              </React.Fragment>
            )
          }} />
          <Route exact path="/editmodule/:id/:courseSlug/:unitSlug/:moduleSlug" render={(routeProps) => {
            return (
              <React.Fragment >
                <div className={headerClasses}>
                  <HeaderModule moduleIden={routeProps.match.params.id} isEditMode={true} />
                </div>
                <div className="module-and-toc-wrapper">
                  <TocMenu moduleIden={routeProps.match.params.id} isEditMode={true} />
                  <ModuleView {...routeProps} {...editModeProps} />
                </div>
                <div className={footerClasses}>
                  <FooterEditModule moduleIden={routeProps.match.params.id} />
                </div>
                <ShadowControl key="shadowControl" version={"editModuleView"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/project/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                {
                  PlatformUtils.isLiveProject() ?
                    <ProjectHomepage {...routeProps} /> :
                    <NotFound {...routeProps} />
                }
                <ShadowControl key="shadowControl" version={"projectDashboard"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/project/:id/:sectionId/:courseSlug?" render={(routeProps) => {
            return (
              <React.Fragment >
                {
                  PlatformUtils.isLiveProject() ?
                    <ProjectHomepage {...routeProps} /> :
                    <NotFound {...routeProps} />
                }
                <ShadowControl key="shadowControl" version={"projectDashboard"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/editCourse/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <EditCourse {...routeProps} />
                <ShadowControl key="shadowControl" version={"editCourse"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/mentor/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                {
                  PlatformUtils.doesHaveMentors ?
                    <MentorUI {...routeProps} /> :
                    <NotFound {...routeProps} />
                }
                <ShadowControl key="shadowControl" version={"mentorUI"} />
              </React.Fragment>
            )
          }} />
          
          <Route exact path="/feedback/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <AggregatedFeedback {...routeProps} />
                <ShadowControl key="shadowControl" version={"aggregatedFeedback"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/adminCourses/" render={(routeProps) => {
            return (
              <React.Fragment >
                <ManageCourses {...routeProps} />
                <ShadowControl key="shadowControl" version={"adminCourses"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/manageCourses/" render={(routeProps) => {
            return (
              <React.Fragment >
                <ManageCourses {...routeProps} />
                <ShadowControl key="shadowControl" version={"manageCourses"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/groupsManager/:id" render={(routeProps) => {
            return (
              <React.Fragment >
                <GroupsManager {...routeProps} />
                <ShadowControl key="shadowControl" version={"groupsManager"} />
              </React.Fragment>
            )
          }} />

          {/* <Route exact path="/groupsRegister/:id/:page" render={(routeProps) => {
            return (
              <React.Fragment >
                <GroupsRegister {...routeProps} />
                <ShadowControl key="shadowControl" version={"groupsRegister"} />
              </React.Fragment>
            )
          }} /> */}

          <Route exact path="/adminTools/" render={(routeProps) => {
            return (
              <React.Fragment >
                <AdminTools {...routeProps} />
                <ShadowControl key="shadowControl" version={"adminTools"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/(about|faq|FAQ)/" render={(routeProps) => {
            return (
              <React.Fragment >
                <FAQ {...routeProps} />
                <ShadowControl key="shadowControl" version={"faq"} />
              </React.Fragment>
            )
          }} />

          <Route exact path="/(info|info/)">
            <Redirect to="/" />
          </Route>

          <Route exact path="/adminTools/social/" render={(routeProps) => {
            return (
              <React.Fragment >
                {
                  PlatformUtils.isLiveProject() ?
                    <Social courseId={...routeProps} /> :
                    <NotFound {...routeProps} />
                }
                <ShadowControl key="shadowControl" version={"adminTools"} />
              </React.Fragment>
            )
          }} />

          <Route component={NotFound} />
        </Switch>
      </Router>
    </Provider>
  </div>,
  document.getElementById('root')
);

